import moment from "moment";

export const tabs = [{ title: "Inventory Setup", value: "1" }];

export const tableData = [
  {
    name: "North",
    description: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    description: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    description: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: false,
  },
  {
    name: "North",
    description: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    description: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    description: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    description: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    description: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    description: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
];
